import React, { useState, useEffect, useRef} from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Tab, Nav, Spinner } from 'react-bootstrap';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import RenderizarFoto from '../components/Utils/RenderizarFoto';
import BarraDeProgresso from '../components/Utils/BarraDeProgresso';
import ReceberValor from '../components/Venda/ReceberValor';
import { Form, Table, Row, Col, InputGroup, FormControl, Button, Card } from "react-bootstrap";
import Swal from 'sweetalert2';
import ReactMarkdown from 'react-markdown';
import Markdown from '../components/Utils/Markdown';
import remarkGfm from 'remark-gfm';
import { useProvider, Toast, isNative } from '../context/MenuProvider';
import html2canvas from 'html2canvas';
import PerfilParte from '../components/Utils/PerfilParte';
import { OpcoesPagamento } from './LinkPagamento';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const baixarCliente = (cliente_id) => {
    const mensagem = {
      tipo: 'baixar-cliente',
      id: parseInt(cliente_id)
    };

    // ✅ FLUXO PWA
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage(mensagem);
    } 
    // ✅ FLUXO NATIVO (APK)
    else {
        // No nativo, enviamos para a própria window pois o service-worker.js
        // foi carregado como um script comum que ouve a window.
        window.dispatchNativeMessage(mensagem);
    }
}


const Parcela = ({ venda, setVenda, id_pagamento, setFormType}) => {
  const [parcela, setParcela] = useState(null);
  const [recarregar, setRecarregar] = useState(false);
  const isInitialRender = useRef(true);
  const navigate = useNavigate();
  const {
    crud,
    buscarDadosPorId,
    salvarDados,
    site,
    handleBaixar,
    handleEnviarWhats,
    handleCompartilhar,
  } = useProvider();
  const { get, post, patch, loading } = crud || {};
  
  
  const isConsultaCarregada = useRef(false);
  const buscarParcelaLocal = async () => {
    try {
      const parLocal = await buscarDadosPorId("db_pagamentos",parseInt(id_pagamento));
      if(parLocal){
        if (isConsultaCarregada.current) return;
        setParcela(parLocal);
        setVenda(parLocal?.venda);
      }
    } catch (err) {

    }finally{

    }
  };
  const buscarParcela = async (parcela_id = null) => {
    try {
      const response = await get(
        `/gvendas/pagamentos/${parcela_id || id_pagamento}/?expand=venda,cliente`,
        "pagina",
      );
      if (response && response.length) {
        isConsultaCarregada.current = true;
        setParcela(response[0]);
        setVenda(response[0]?.venda);
      }
    } catch (err) {
      if(err.response?.status === 404){
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente));
        navigate(`/vendas/${venda.id}`, {replace:true});
        setFormType('pagamentos');
      }
      console.error(err);
    }finally{
      
    }
  };
  
  
  const setDataPagamento = (value) => {
    if(!parcela.pago){
      setParcela((prevParcela) => ({
        ...prevParcela,
        data_do_pagamento: value
      }))
    }
  }
  const setFormaPagamento = (value) => {
    if(!parcela.pago){
      setRecarregar(true);
      setParcela((prevParcela) => ({
        ...prevParcela,
        forma_de_pagamento: value,
      }))
    }
  }
  const setTaxasPagamento = (value) => {
    if(!parcela.pago){
      setParcela((prevParcela) => ({
        ...prevParcela,
        taxas: value,
      }))
    }
  }

  const atualizarParcela = async (data = null) => {
    const formData = {
        'data_do_pagamento':data?.data_do_pagamento || parcela.data_do_pagamento,
        'data_do_vencimento':data?.data_do_vencimento || parcela.data_do_vencimento||null,
        'pago': data?.pago || parcela.pago,
        'forma_de_pagamento': data?.forma_de_pagamento || parcela.forma_de_pagamento,
        'taxas': (data?.forma_de_pagamento || parcela.forma_de_pagamento) === "Cartao"?(data.taxas || parcela.taxas || 0) : 0,
    }
    
    try{
      const response = await patch(formData, `/gvendas/pagamentos/${parcela.id}/?filtros=id,venda,cliente&expand=venda`);
      //alert(JSON.stringify(response))
      if(response && response.length && recarregar){
        setRecarregar(false);
        //const tPago = parcela.pago ? parseFloat(venda.total_pago) + parseFloat(parcela.valor) : parseFloat(venda.total_pago) - parseFloat(parcela.valor)
        // if (parseFloat(venda.total_pago) !== tPago) {
        //   response[0].venda = {
        //     ...response[0].venda,
        //     //total_pago: tPago,
        //   }
        // }
        //setParcela(response[0]);
        //setVenda(response[0].venda);
        await buscarParcela(response[0].id);
        baixarCliente(parseInt(response[0]?.venda?.cliente?.id || response[0]?.venda?.cliente))
      }
    }catch(err){
      //alert(JSON.stringify(err.response))
      if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
        const cliLocal = venda?.cliente?.nome_do_cliente ? venda?.cliente : null;
        if(cliLocal) return;
        await salvarDados('db_sync', {
          id:`parcela_${parcela.id}`,
          metodo: "PATCH",
          titulo: `Atualizando Parcela ${parseFloat(parseFloat(parcela.valor || 0)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`,
          descricao: `
            <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>${cliLocal?.nome_do_cliente || 'Cliente não informado'}</th></tr>
              </thead>
              <tbody>
                <tr><td>Pago: ${parcela?.pago?'Sim':'Não'}</td></tr>
                <tr><td>Pagamento: ${parcela?.forma_de_pagamento}</td></tr>
                <tr><td>Data: ${dayjs(parcela?.data_do_pagamento).format("DD/MM/YYYY")}</td></tr>
              </tbody>
            </div>
          `,
          url: `/gvendas/pagamentos/${parcela.id}/?expand=venda,cliente`,
          dados: formData,
          tipo:"baixar-cliente",
          id:parseInt(venda?.cliente?.id || venda?.cliente),
          data: new Date().toLocaleString("sv-SE"),
        });
        //Colocar url da fila;
        navigate(`/painel/sync`, { replace: true });
      }
    }finally{
        
    }
  }
  
  useEffect(()=>{
    if(parcela){
      if (isInitialRender.current) {
        isInitialRender.current = false;
        return; // Ignora o carregamento inicial
      }
      atualizarParcela();
    }
  },[parcela])
  
  
  const enviarWhatsApp = async (mensagem) => {
    await handleEnviarWhats(venda?.cliente?.telefone, mensagem);
  };
  

  // Inicialização
  useEffect(() => {
    if (id_pagamento && venda?.id) {
      buscarParcelaLocal();
      buscarParcela();
    }
  }, [id_pagamento, venda?.id, venda?.juros_por_atraso]);
  
  return (
    <>
      <Row className="justify-content-center">
        <Col xs="auto" className="text-center pt-4 d-flex align-items-center">
          <span className="fs-1 me-2">
            {parseFloat(parcela?.total_de_juros_multa||0)>0?(
              <>
                <span className="fs-5">
                  <i className="bi bi-info"></i>
                  <s className="small">
                    {parseFloat(parcela?.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  </s>
                </span>
                {` `}
                {parseFloat(parcela?.valor_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </>
            ):(
              <>
                {parseFloat(parcela?.valor || parcela?.valor_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </>
            )}
          </span>
          <Button variant="secondary" disabled={parcela?.pago} onClick={()=>setFormType('editar-pagamentos')} className="btn-sm p-0" style={{ fontSize: '0.75rem', width: 'auto', height: 'auto' }}>
            Editar Valor
          </Button>
        </Col>
      </Row>
      <div className="pb-3 text-center">
        Parcela {(parcela?.referencia||'').split(' ')[0]} {parcela?.pago?'paga em':'agendada para'} {dayjs(parcela?.data_do_pagamento).format("DD/MM/YYYY")}
      </div>
      <Table bordered>
        <tbody>
          <tr>
            <td>
              <Row className="align-items-center">
                <Col>
                  Forma de recebimento
                </Col>
                <Col xs="auto">
                  <Form.Select
                    disabled={parcela?.pago}
                    value={parcela?.forma_de_pagamento}
                    onChange={(e) =>setFormaPagamento(e.target.value)}
                  >
                    <option value="pix">Pix</option>
                    <option value="dinheiro">Dinheiro</option>
                    <option value="cartao">Cartão</option>
                    <option value="online">Link de pagamento</option>
                  </Form.Select>
                </Col>
              </Row>
            </td>
          </tr>
          {parcela?.forma_de_pagamento === "Cartao" && (
            <tr>
              <td>
                <Row className="align-items-center">
                  <Col>Taxas da máquina</Col>
                  <Col xs={4}>
                    <Form.Control
                      readOnly={parcela?.pago}
                      type="number"
                      value={parcela?.taxas}
                      placeholder="0,00"
                      onChange={(e) =>setTaxasPagamento(e.target.value)}
                      onBlur={(e) => setTaxasPagamento(parseFloat(e.target.value || 0).toFixed(2))}
                    />
                  </Col>
                </Row>
              </td>
            </tr>
          )}
          {venda?.juros_por_atraso && (
            <>
              <tr>
                <td>
                  <Row className="align-items-center">
                    <Col>Data do vencimento inicial</Col>
                    <Col xs="auto">
                      <Form.Control
                        readOnly={parcela?.pago}
                        type="date"
                        value={parcela?.data_do_vencimento}
                        onChange={(e) =>{
                          setRecarregar(true);
                          setParcela((prevParcela) => ({
                            ...prevParcela,
                            data_do_vencimento: e.target.value
                          }));
                        }}
                      />
                    </Col>
                  </Row>
                </td>
              </tr>
            </>
          )}
          <tr>
            <td>
              <Row className="align-items-center">
                <Col>Data {parcela?.pago?"de recebimento":"de vencimento"}</Col>
                <Col xs="auto">
                  <Form.Control
                    readOnly={parcela?.pago}
                    type="date"
                    value={parcela?.data_do_pagamento}
                    onChange={(e) =>{
                      setRecarregar(true);
                      setDataPagamento(e.target.value);
                    }}
                  />
                </Col>
              </Row>
            </td>
          </tr>
          {venda?.juros_por_atraso && (
            <>
              <tr>
                <td>
                  <Row className="align-items-center">
                    <Col>Juros e multa</Col>
                    <Col xs="auto">
                      {parseFloat(parcela?.total_de_juros_e_multa || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </Col>
                  </Row>
                </td>
              </tr>
            </>
          )}
          <tr>
            <td>
              <Row className="align-items-center">
                <Col>Pagamento recebido?</Col>
                <Col xs="auto fs-3">
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label=""
                    checked={parcela?.pago}
                    onChange={(e) =>{
                      setRecarregar(true);
                      setParcela((prevParcela) => ({
                        ...prevParcela,
                        pago: e.target.checked,
                      }));
                    }}
                  />
                </Col>
              </Row>
            </td>
          </tr>
        </tbody>
      </Table>
      <Row>
        <Col className="text-center py-4">
          Status de pagamento - Venda em {dayjs(venda?.data_da_venda).format("DD/MM/YYYY")}
        </Col>
      </Row>
      <Table>
        <tbody>
          <tr>
            <td>
              <Row>
                <Col>Recebido</Col>
                <Col className="text-end">Total da Venda</Col>
              </Row>
              <BarraDeProgresso valor={venda?.total_pago} total={venda?.total} variant="secondary"/>
              <Row>
                <Col>{parseFloat(venda?.total_pago||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
                <Col className="text-end">{parseFloat(venda?.total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
              </Row>
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};
const Pagamento = ({ venda, setVenda, setFormType }) => {
  const {
    crud,
    buscarDados,
    site,
  } = useProvider();
  const { get, patch, loading } = crud || {};
  const [pagamentos, setPagamentos] = useState([]);
  
  const isConsultaCarregada = useRef(false);
  const buscarPagamentosLocal = async() => {
    try{
      const response = await buscarDados(
          "db_pagamentos",
          (item) => parseInt(item.venda?.id) === parseInt(venda?.id),
          15,
          "data_do_pagamento",
          "desc"
      );
      if(response && response.length){
        if (isConsultaCarregada.current) return;
        setPagamentos(response);
      }
    }catch(err){
      
    }finally{
      
    }
  }
  const buscarPagamentos = async() => {
    try{
      const response = await get(`/gvendas/pagamentos/?venda__in=${venda.id}&ordering=data_do_pagamento&limit=1000`,"pagina");
      if(response && response.length){
        isConsultaCarregada.current = true;
        setPagamentos(response[0].results);
      }
    }catch(err){
      
    }finally{
      
    }
  }
  
  const atualizarPagamento = async(parcela) => {
    try{
      const formData = new FormData();
      formData.append('data_do_pagamento', parcela.data_do_pagamento);
      formData.append('pago', parcela.pago);
      formData.append('forma_de_pagamento', parcela.forma_de_pagamento);
      if(parcela.forma_de_pagamento === "Cartao"){
        formData.append('taxas', parseFloat(parcela.taxas||0));
      }else{
        formData.append('taxas', 0);
      }
      const response = await patch(formData, `/gvendas/pagamentos/${parcela.id}/`);
      if(response){
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente))
        return response[0];
      }
    }catch(err){

    }finally{
      
    }
  }
  
  const parseTaxas = (index, value) => {
    const novaTabela = [...pagamentos];
    novaTabela[index].taxas = value;
    setPagamentos(novaTabela);
  }
  
  // Função para lidar com alterações nos inputs
  const handleInputChange = async(index, field, value) => {
    const novaTabela = [...pagamentos];
    
    
    if (field === "data_do_pagamento" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;
      novaTabela[index]= await atualizarPagamento(novaTabela[index]);
    }
    
    if (field === "data_do_vencimento" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;
      novaTabela[index]= await atualizarPagamento(novaTabela[index]);
    }
    
    if (field === "taxas" && !novaTabela[index].pago) {
      if (novaTabela[index].forma_de_pagamento === "Dinheiro"){
        novaTabela[index][field] = 0;
      }else{
        novaTabela[index][field] = value.value;
      }
      novaTabela[index]= await atualizarPagamento(novaTabela[index]);
    }
    
    
    if (field === "forma_de_pagamento" && !novaTabela[index].pago) {
      if(value.value === "Dinheiro")
      {
        novaTabela[index]["taxas"] = (0).toFixed(2);
      }
      novaTabela[index][field] = value.value;
      novaTabela[index]= await atualizarPagamento(novaTabela[index]);
    }

    // Se o campo for "pago", congela o valor quando pago
    if (field === "pago") {
      novaTabela[index][field] = value.checked;
      novaTabela[index]= await atualizarPagamento(novaTabela[index]);
      setVenda((prevVenda)=>({
        ...prevVenda,
        total_pago:value.checked?prevVenda.total_pago + parseFloat(novaTabela[index].valor):prevVenda.total_pago - parseFloat(novaTabela[index].valor),
      }))
    }
    
    
    const pagamento = novaTabela[index];
    
    novaTabela.sort((a, b) => new Date(a.data_do_pagamento) - new Date(b.data_do_pagamento));
    setPagamentos(novaTabela);
  };
  
  useEffect(()=>{
    if(venda){
      buscarPagamentosLocal();
      buscarPagamentos();
    }
  },[venda?.id])
  
  return (
    <div className="pb-5">
      {pagamentos?.map((linha, index) => (
        <Card className="my-3 p-2">
          <Row className="align-items-center">
            <Col>
              <InputGroup size="sm" className="mb-1">
                <InputGroup.Text>Tipo</InputGroup.Text>
                <Form.Select
                  disabled={linha.pago}
                  value={linha.forma_de_pagamento}
                  onChange={(e) => handleInputChange(index, "forma_de_pagamento", e.target)}
                >
                  <option value="pix">Pix</option>
                  <option value="dinheiro">Dinheiro</option>
                  <option value="cartao">Cartão</option>
                  <option value="online">Link de pagamento</option>
                </Form.Select>
              </InputGroup>
              {linha.forma_de_pagamento === "Cartao" && (
                <InputGroup size="sm">
                  <InputGroup.Text>Taxas</InputGroup.Text>
                  <FormControl
                      readOnly={linha.pago}
                      type="number"
                      placeholder="0,00"
                      value={linha.taxas}
                      onChange={(e) =>
                        handleInputChange(index, "taxas", e.target)
                      }
                      onBlur={(e)=>parseTaxas(index, parseFloat(e.target.value||0).toFixed(2))}
                  />
                </InputGroup>
              )}
            </Col>
            <Col className="text-end fs-5">
              {parseFloat(linha.valor_total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </Col>
            <Col className="col-12 pt-1 pb-2">
              <div className="border-thin border"></div>
            </Col>
            <Col xs="auto">
              <InputGroup>
                <InputGroup.Text>Data</InputGroup.Text>
                <FormControl
                    type="date"
                    readOnly={linha.pago}
                    value={linha.data_do_pagamento}
                    onChange={(e) =>
                      handleInputChange(index, "data_do_pagamento", e.target)
                    }
                />
              </InputGroup>
            </Col>
            <Col className="fs-5 d-flex align-items-end justify-content-end">
                <Form.Check
                    type="switch"
                    id={`custom-switch-${index}`}
                    label={<span className="fs-6">Recebido</span>}
                    checked={linha.pago}
                    onChange={(e) => handleInputChange(index, "pago", e.target)}
                />
            </Col>
          </Row>
        </Card>
      ))}
      <div className="text-center">
          <Button
            variant="secondary"
            className="mb-5 mt-3 btn-sm px-5 mx-auto"
            onClick={()=>setFormType('editar-pagamentos')}
          >
            Editar pagamentos
          </Button>
      </div>
    </div>
  );
};
const PagamentoEditar = ({ venda, jurosMulta, setVenda, setFormType}) => {
  const {
    crud,
    auth,
    buscarDados,
    salvarDados,
    buscarDadosPorId,
    site,
  } = useProvider();
  
  const navigate = useNavigate();
  const { get, post, patch, del, loading } = crud;
  const [pagamentos, setPagamentos] = useState([]);
  const [empresa, setEmpresa] = useState(auth?.empresa);
  
  const [naUltima, setNaUltima] = useState(true);
  
  
  const isConsultaCarregada = useRef(false);
  const buscarPagamentosLocal = async() => {
    try{
      const response = await buscarDados(
          "db_pagamentos",
          (item) => parseInt(item.venda?.id) === parseInt(venda?.id),
          15,
          "data_do_pagamento",
          "desc"
      );
      if(response && response.length){
        if (isConsultaCarregada.current) return;
        setPagamentos(response);
      }
    }catch(err){
      
    }finally{
      
    }
  }
  const buscarPagamentos = async() => {
    try{
      const response = await get(`/gvendas/pagamentos/?venda__in=${venda.id}&ordering=data_do_pagamento&limit=1000`,"pagina");
      if(response && response.length){
        isConsultaCarregada.current = true;
        setPagamentos(response[0].results);
      }
    }catch(err){
      
    }finally{
      
    }
  }
  
  
  const updateDesconto = async () => {
    try{
      const formData = new FormData();
      formData.append('desconto', parseFloat(venda?.desconto||0).toFixed(2));
      const response = await patch(formData, `/gvendas/vendas/${venda.id}/?expand=cliente`);
      if(response &&response.length){
        setVenda(response[0]);
        ajustarTotalDaCompra()
      }
    }catch(err){
      
    }finally{
      
    }
  }
  const addParcela = async (item) => {
    try{
      //alert(`Add: ${JSON.stringify(item)}`)
      return await post(item, `/gvendas/pagamentos/`);
    }catch(err){
      
    }finally{
      
    }
  }
  const updateParcela = async (item) => {
    try{
      //alert(`Update: ${JSON.stringify(item)}`)
      return await patch(item, `/gvendas/pagamentos/${item.id}/`);
    }catch(err){
      
    }finally{
      
    }
  }
  const deleteParcela = async (id) => {
    try{
      await del(`/gvendas/pagamentos/${id}/`);
    }catch(err){
      
    }finally{
      
    }
  }
  
  const pagamentoToItem = (item) => {
      return { 
          id:item.id,
          valor:parseFloat(item.valor||0), 
          pago:item.pago,
          taxas:parseFloat(item.taxas ||0),
          data_do_pagamento:item.data_do_pagamento,
          data_do_vencimento:item.data_do_vencimento || null,
          forma_de_pagamento:item.forma_de_pagamento,
      };
  }
  
  const salvarPagamentos = async(redirecionar = true) => {
    let lista = [];
    pagamentos.forEach((item) => {
        lista.push(pagamentoToItem(item));
      });
    const formData = {
        "desconto":parseFloat(venda.desconto||0),
        "venda_pagamentos":lista,
    }
    
    try{
      //alert(JSON.stringify(formData))
      const response = await patch(formData,`/gvendas/vendas/${venda?.id}/`);
      if (response && response.length){
        //alert(JSON.stringify(response[0]))
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente))
        if(redirecionar){
          setFormType('comprovante');
        }
      }
      
      // const response = await get(`/gvendas/pagamentos/?venda__in=${venda.id}&ordering=data_do_pagamento&limit=1000`,'pagina');
      // if(response && response.length){
      //   let results = response[0].results;
        
      //   await updateDesconto();
        
      //   //Adicionar pagamentos
      //   let listaAdd = lista.filter(x => x.id == null);
      //   await Promise.all(
      //     listaAdd.map(async (item) => {
      //       item.venda = venda.id;
      //       await addParcela(item);
      //     })
      //   );
        
      //   ///Atualizar pagamentos
      //   let listaUpdate = lista.filter(x => x.id != null);
      //   await Promise.all(
      //     listaUpdate.map(async (item) => {
      //       item.venda = venda.id;
      //       await updateParcela(item);
      //     })
      //   );
       
      //   let listaIds = lista.map(item => parseInt(item.id));
      //   let listaIds_set = results.map(item => parseInt(item.id));
      //   let listaDelete = listaIds_set.filter(item => !listaIds.includes(item));
      //   ///Exclir pagamento
      //   await Promise.all(
      //     listaDelete.map(async (item) => {
      //       await deleteParcela(item);
      //     })
      //   );
      //   if(redirecionar){
      //     setFormType('comprovante');
      //   }
      // }
    }catch(err){
      //alert(JSON.stringify(err.response.data))
      if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
        const id_cliente = venda?.cliente?.id || venda?.cliente;
        const cliLocal = venda?.cliente?.nome_do_cliente?venda?.cliente:await buscarDadosPorId("db_clientes", id_cliente); //await buscarDadosPorId("db_clientes", parseInt(id_cliente));
        await salvarDados('db_sync', {
          //id:`recebimento_${cliLocal?.nome_do_cliente || id_cliente}`,
          returnUrl:`/clientes/${cliLocal?.id}`,
          metodo: "PATCH",
          titulo: `Atualização de pagamentos`,
          info: `${cliLocal?.nome_do_cliente || `Cliente Id: ${id_cliente}`}`,
          descricao: `
            <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>${cliLocal?.nome_do_cliente || `Cliente Id: ${id_cliente}`}</th></tr>
              </thead>
            </div>
          `,
          url: `/gvendas/vendas/${venda?.id}/`,
          dados: formData,
          tipo:"baixar-cliente",
          id: parseInt(venda?.cliente?.id || venda?.cliente),
          data: new Date().toLocaleString("sv-SE"),
        });
        //Colocar url da fila;
        Toast.fire({
          icon: 'success',
          title: 'Atualizações adicionado na lista de espera de conexão!'
        });
        navigate(`/painel/sync`, { replace: true });
      }
      else {
        Swal.fire({
            title: `Erro ${err.status || err.code}`,
            text: err.response?.data?.detail || 'Falha ao atualizar pagamentos',
            icon: "error"
        });
      }
    }finally{

    }
  }
  
  const gerarLinha = () => {
    if (pagamentos.length <= 0) {
        return adicionarLinha();
    }

    const totalPago = pagamentos.filter(x => x.pago).reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;

    const total = parseFloat(venda?.sub_total || 0);
    const desconto = parseFloat(venda?.desconto || 0);
    const totalAberto = total - totalPago - desconto;

    const temLinhaAberto = pagamentos.some(x => !x.pago);
    
    if (totalAberto > 0 && !temLinhaAberto) {
        adicionarLinha();
    }
  };

  const setDesconto = (value) => {
    // Converte o valor para número ou define como 0 se inválido
    let valor = parseFloat(value || 0);
  
    // Garante que o desconto não seja negativo
    if (valor < 0) {
      valor = 0;
    } else {
      // Obtém o total da venda
      const total = parseFloat(venda?.sub_total || 0);
  
      // Verifica se há pagamentos marcados como "pago"
      const pagamentosPagos = pagamentos.filter((x) => x.pago);
      const temLinhaPago = pagamentosPagos.length > 0;
  
      // Calcula o total pago
      const totalPago = pagamentosPagos.reduce(
        (acc, linha) => acc + parseFloat(linha.valor || 0),
        0
      );
  
      // Calcula o total em aberto
      let totalAberto = total - totalPago;
      //se o total do desconto é o mesmo de valor em aberto e nao tem nenhum pago
      if (!temLinhaPago) {
        totalAberto -= 0.01; // Ajuste conforme a lógica específica
      }
  
      // Garante que o valor do desconto não exceda o total aberto
      if (valor > totalAberto) {
        valor = parseFloat(totalAberto.toFixed(2));
      }
    }
    
    
    // Atualiza o estado da venda com o novo desconto
    setVenda((prevVenda) => ({
       ...prevVenda,
       total: prevVenda?.sub_total - parseFloat(valor||0) + totalDeJuros(),
       desconto: value?valor:value,
    }));
  };
  
  const ajustarTotalDaCompra = () => {
    setVenda((prevVenda) => ({
       ...prevVenda,
       total: parseFloat(prevVenda?.sub_total) - parseFloat(prevVenda?.desconto||0) + totalDeJuros()
    }));
  }

  // Função para dividir o total da sacola pelas linhas não paga
  const dividirTotal = async() => {
    const linhasNaoPagas = pagamentos.filter((linha) => !linha.pago) || [];
    const totalGeral = parseFloat(venda?.sub_total || 0) - parseFloat(venda?.desconto||0);
  
    // Subtrai o valor das linhas pagas do total restante
    const valorCongelado = pagamentos.filter((linha) => linha.pago)
      .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;
  
    const totalRestante = totalGeral - valorCongelado;
    
    let novaTabela = [];
    //Ajustar para ultima linha se tiver valor nao pago
    if (naUltima && linhasNaoPagas.length > 0) {
      const valorTotal = pagamentos.filter((linha) => !linha.pago)
        .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0) || 0;
  
      // Se naUltima for true, apenas altera a última linha não paga
      const ultimaLinhaNaoPaga = linhasNaoPagas[linhasNaoPagas.length - 1];
  
      // Atualiza o valor da última linha não paga com o valor total restante
      ultimaLinhaNaoPaga.valor = (totalRestante - valorTotal + parseFloat(ultimaLinhaNaoPaga.valor||0)).toFixed(2) //(totalGeral - valorTotal).toFixed(2);
      //alert(`Valor Total: ${valorTotal} Valor Geral: ${totalGeral} Diferença: ${ultimaLinhaNaoPaga.valor}`);
  
      // Atualiza a tabela com o novo valor da última linha
      novaTabela = pagamentos.map((linha) =>
        linha === ultimaLinhaNaoPaga ? ultimaLinhaNaoPaga : linha
      );
  
      // Exclui as linhas com valor <= 0
      novaTabela = novaTabela.filter((linha) => (parseFloat(linha.valor) > 0 || linha.valor===""));
      if (JSON.stringify(pagamentos) !== JSON.stringify(novaTabela)) {
        setPagamentos(novaTabela);
      }
      
    } else if (linhasNaoPagas.length > 0) {
      // Caso contrário, divide o valor entre todas as linhas não pagas
      let valorPorLinha =
        linhasNaoPagas.length > 0 ? totalRestante / linhasNaoPagas.length : 0;
  
      // Arredonda o valor por linha para 2 casas decimais
      valorPorLinha = Math.round(valorPorLinha * 100) / 100;
  
      // Calcula a diferença do total geral, considerando o arredondamento
      const somaValorPorLinha = valorPorLinha * linhasNaoPagas.length;
      const ajuste = totalRestante - somaValorPorLinha;
  
      // Atualiza a última linha para corrigir a diferença
      novaTabela = pagamentos.map((linha, index) => {
        if (!linha.pago) {
          const valorAtualizado =
            index === linhasNaoPagas.length - 1
              ? (valorPorLinha + ajuste).toFixed(2)
              : valorPorLinha.toFixed(2);
          return { ...linha, valor: valorAtualizado };
        }
        return linha;
      });
  
      // Exclui as linhas com valor <= 0
      novaTabela = novaTabela.filter((linha) => parseFloat(linha.valor) > 0 || linha.valor==="");
      novaTabela = await Promise.all(
          novaTabela.map(async (item) => {
            const result = item.pago ? item.total_de_juros_e_multa : await calcularJurosMulta(
              parseFloat(item.valor),
              item.data_do_vencimento,
              item.data_do_pagamento
            );
            return { ...item, total_de_juros_e_multa: result };
          })
      );
      if (JSON.stringify(pagamentos) !== JSON.stringify(novaTabela)) {
        setPagamentos(novaTabela);
      }
    }
    
    
  };
  
  // Função para ajustar a última linha não paga
  const ajustarUltimaLinhaNaoPaga = () => {
    const linhasNaoPagas = pagamentos.filter((linha) => !linha.pago)||[];
    const totalNaoPagos = parseFloat(venda?.sub_total || 0) - parseFloat(venda?.desconto||0);

    const valorCongelado = pagamentos.filter((linha) => linha.pago)
      .reduce((acc, linha) => acc + parseFloat(linha.valor || 0), 0)||0;

    const totalRestante = totalNaoPagos - valorCongelado;

    const valorPorLinha = totalRestante / linhasNaoPagas.length;

    const novaTabela = pagamentos.map((linha, index) => {
      if (!linha.pago && index === pagamentos.length - 1) {
        return { ...linha, valor: valorPorLinha.toFixed(2) };
      }
      return linha;
    });

    setPagamentos(novaTabela);
  };

  // Função para adicionar uma nova linha com a data ajustada
  const adicionarLinha = () => {
    try {
      //setNaUltima(false);
      let novaData;
      if (pagamentos.length > 0) {
        // Se houver pelo menos uma linha, adiciona 7 dias à última data
        const ultimaLinha = pagamentos[pagamentos.length - 1];
        novaData = new Date(ultimaLinha.data_do_pagamento);
  
        if (isNaN(novaData)) throw new Error("Data inválida na última linha.");
        
        const dias_parcelamento = empresa?.configuracoes?.dias_parcelamento || 7;
        novaData.setDate(novaData.getDate() + dias_parcelamento); // Adiciona 7 dias à última data
      } else {
        // Se não houver nenhuma linha, usa a data inicial
        novaData = new Date(venda?.data_da_venda || Date.now());
  
        if (isNaN(novaData)) throw new Error("Data inicial inválida.");
      }
  
      const novaLinha = {
        valor: (0).toFixed(2),
        taxas: (0).toFixed(2),
        juros_e_multa: (0).toFixed(2),
        pago: false,
        data_do_pagamento: novaData.toLocaleDateString("sv-SE"), // Formata para 'YYYY-MM-DD'
        forma_de_pagamento: 'pix',
      };
  
      const novaTabela = [...pagamentos, novaLinha];
  
      novaTabela.sort((a, b) => new Date(a.data_do_pagamento) - new Date(b.data_do_pagamento)); // Ordena as linhas pela data
      
      setPagamentos(novaTabela);
    } catch (error) {
      console.error("Erro ao adicionar linha:", error.message);
    }
  };

  // Função para remover uma linha da tabela
  const removerLinha = (index) => {
    const novaTabela = pagamentos.filter((linha, i) => i != index || linha.pago);
    setPagamentos(novaTabela);
  };
  
  
  const totalDeJuros = () => {
    return pagamentos.reduce((acc, linha) => acc + parseFloat(linha.total_de_juros_e_multa || 0), 0);
  }
  
  const calcularJurosMulta = async(valor, data_do_vencimento, data_do_pagamento) => {
    try{
      if (!data_do_vencimento || !jurosMulta?.juros_mensal || !venda?.juros_por_atraso) return (0).toFixed(2);
      const dataForm = {
        valor_inicial:valor,
        data_do_pagamento:data_do_pagamento,
        data_do_vencimento:data_do_vencimento
      }
      const response = await post(dataForm, `/gvendas/juros/simular_juros/`);
      if(response.length){
        return parseFloat(response[0].total ||0);
      }
    }catch(err){
      
    }
  }

  // Função para lidar com alterações nos inputs
  const handleInputChange = async(index, field, value) => {
    const novaTabela = [...pagamentos];

    // Se o campo for "valor" e a linha não está paga
    if (field === "valor" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;
      if(venda?.juros_por_atraso && parseFloat(value.value ||0)>0){
        novaTabela[index]['total_de_juros_e_multa'] = await calcularJurosMulta(
          parseFloat(novaTabela[index].valor),
          novaTabela[index].data_do_vencimento,
          novaTabela[index].data_do_pagamento,
        );
      }
      ajustarUltimaLinhaNaoPaga();
    }
    
    if (field === "data_do_pagamento" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;
      if(venda?.juros_por_atraso){
        novaTabela[index]['total_de_juros_e_multa'] = await calcularJurosMulta(
          parseFloat(novaTabela[index].valor),
          novaTabela[index].data_do_vencimento,
          novaTabela[index].data_do_pagamento,
        );
        if (novaTabela[index].id){
          updateParcela(pagamentoToItem(novaTabela[index]));
        }
      }
    }
    
    if (field === "data_do_vencimento" && !novaTabela[index].pago) {
      novaTabela[index][field] = value.value;
      if(venda?.juros_por_atraso){
        novaTabela[index]['total_de_juros_e_multa'] = await calcularJurosMulta(
          parseFloat(novaTabela[index].valor),
          novaTabela[index].data_do_vencimento,
          novaTabela[index].data_do_pagamento,
        );
        if (novaTabela[index].id){
          updateParcela(pagamentoToItem(novaTabela[index]));
        }
      }
    }
    
    if (field === "taxas" && !novaTabela[index].pago) {
      if (novaTabela[index].forma_de_pagamento === "Dinheiro"){
        novaTabela[index][field] = 0;
      }else{
        novaTabela[index][field] = value.value;
      }
    }
    
    if (field === "forma_de_pagamento" && !novaTabela[index].pago) {
      if(value.value === "Dinheiro")
      {
        novaTabela[index]["taxas"] = (0).toFixed(2);
      }
      novaTabela[index][field] = value.value;
    }

    // Se o campo for "pago", congela o valor quando pago
    if (field === "pago") {
      novaTabela[index][field] = value.checked;
    }

    // Verifica se a última linha tem valor <= 0 e não está paga
    if (novaTabela[novaTabela.length - 1].valor <= 0 && !novaTabela[novaTabela.length - 1].pago && value && novaTabela[novaTabela.length - 1].valor !== "") {
      novaTabela.pop(); // Remove a última linha se o valor for <= 0
    }
    
    // Reordena a tabela pela data, mesmo que a linha tenha sido paga
    novaTabela.sort((a, b) => new Date(a.data_do_pagamento) - new Date(b.data_do_pagamento));

    // Atualiza a tabela
    setPagamentos(novaTabela);
  };
  const handleInputChangeFixed = async(index, field, value) => {
    const novaTabela = [...pagamentos];

    // Se o campo for "valor" e a linha não está paga
    if (field === "valor" && !novaTabela[index].pago) {
      novaTabela[index][field] = parseFloat(value.value||0).toFixed(2);
      
      if(venda?.juros_por_atraso && parseFloat(value.value ||0)>0){
        novaTabela[index]['total_de_juros_e_multa'] = await calcularJurosMulta(
          parseFloat(novaTabela[index].valor),
          novaTabela[index].data_do_vencimento,
          novaTabela[index].data_do_pagamento,
        );
        // if (novaTabela[index].id){
        //     const result = await updateParcela(pagamentoToItem(novaTabela[index]));
        //     alert(JSON.stringify(result))
        // }
      }
    }
    if (field === "taxas" && !novaTabela[index].pago) {
      if (novaTabela[index].forma_de_pagamento === "Dinheiro"){
        novaTabela[index][field] = (0).toFixed(2);
      }else{
        novaTabela[index][field] = parseFloat(value.value||0).toFixed(2);
      }
    }
    
        // Verifica se a última linha tem valor <= 0 e não está paga
    if (novaTabela[novaTabela.length - 1].valor <= 0 && !novaTabela[novaTabela.length - 1].pago && value && novaTabela[novaTabela.length - 1].valor !== "") {
      novaTabela.pop(); // Remove a última linha se o valor for <= 0
    }

    // Atualiza a tabela
    setPagamentos(novaTabela);
  }
  
  
  useEffect(() => {
    gerarLinha();
    dividirTotal();
    ajustarTotalDaCompra();
  }, [pagamentos, venda?.desconto]);
  
  
  useEffect(()=>{
    if(venda?.id){
      buscarPagamentosLocal();
      buscarPagamentos();
    }
  },[venda?.id])
  

  return (
    <div className="pb-5">
      <div className="bs-floating shadow navbar-light">
        <div className="container py-2">
          <Button variant="secondary" onClick={salvarPagamentos} disabled={loading} className="w-100 btn-lg">
              Salvar alterações
          </Button>
        </div>
      </div>
      <Row className="align-items-center">
        <Col>
          <div className="small text-muted">{totalDeJuros()>0?(
            <>
              Juros e multa {totalDeJuros().toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </>
          ):"Total da venda"}</div>
          <div className="fs-4">
            {parseFloat(venda?.desconto)>0 && (
              <>
                <s className="text-muted fs-6 me-2">
                  {parseFloat(venda?.sub_total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </s>
              </>
            )}
            {parseFloat(venda?.total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
          </div>
        </Col>
        <Col>
          <small className="text-muted">Desconto</small>
          <div className="input-group">
            <span className="input-group-text">R$</span>
            <input
              type="number"
              className="form-control"
              value={venda?.desconto}
              onChange={(e) => setDesconto(e.target.value)}
              onBlur={(e) => setVenda((prevVenda) => ({
                ...prevVenda,
                desconto: parseFloat(e.target.value||0).toFixed(2),
              }))}
            />
          </div>
        </Col>
      </Row>
      <h6 className="border-dashed-bottom">Forma de pagamento</h6>
      <div className="table-responsive">
        <table className="table w-100">
          <thead>
            <tr>
              <th>Valor</th>
              <th>Taxas</th>
              {(venda?.juros_por_atraso || parseFloat(venda?.juros_multa)>0) && (
                <>
                  <th>Juros</th>
                  <th>Ref. Juros</th>
                </>
              )}
              <th>Data Pgmt</th>
              <th>Pago</th>
              <th>Pagamento</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {pagamentos.map((linha, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="number"
                    className="form-control preco moeda"
                    value={linha.valor}
                    readOnly={linha.pago} // Congela o valor quando pago
                    onChange={(e) => handleInputChange(index, "valor", e.target)}
                    onBlur={(e) => { handleInputChangeFixed(index, "valor", e.target);}}
                    onFocus={(e) => { setNaUltima(true); }} // Função ao focar
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    value={linha.taxas}
                    readOnly={linha.pago || linha.forma_de_pagamento === "Dinheiro"}
                    onChange={(e) => {handleInputChange(index, "taxas", e.target);}}
                    onBlur={(e) => {handleInputChangeFixed(index, "taxas", e.target);}}
                  />
                </td>
                 {(venda?.juros_por_atraso || parseFloat(venda?.juros_multa)>0) && (
                   <>
                    <td>
                      <input
                        type="number"
                        className="form-control"
                        value={linha.total_de_juros_e_multa}
                        readOnly={true}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className="form-control"
                        value={linha.data_do_vencimento}
                        readOnly={linha.pago || !venda?.juros_por_atraso}
                        onChange={(e) => {handleInputChange(index, "data_do_vencimento", e.target);}}
                      />
                    </td>
                   </>
                 )}
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={linha.data_do_pagamento}
                    readOnly={linha.pago}
                    onChange={(e) => {handleInputChange(index, "data_do_pagamento", e.target);}}
                  />
                </td>
                <td
                  className="justify-content-center align-items-center text-center fs-5"
                  style={{ verticalAlign: "middle" }}
                >
                  <Form.Check
                    type="switch"
                    id={`custom-switch-${index}`}
                    checked={linha.pago}
                    onChange={(e) => handleInputChange(index, "pago", e.target)}
                  />
                </td>
                <td>
                  <select
                    className="form-select form-select-sm"
                    value={linha.forma_de_pagamento}
                    disabled={linha.pago}
                    onChange={(e) => {handleInputChange(index, "forma_de_pagamento", e.target);}}
                  >
                    <option value="pix">Pix</option>
                    <option value="dinheiro">Dinheiro</option>
                    <option value="cartao">Cartão</option>
                    <option value="online">Link</option>
                  </select>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => {removerLinha(index); setNaUltima(false);}}
                  >
                    <i className="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-center">
          <button
            className="btn btn-dark mb-5 mt-3 btn-sm w-100"
            onClick={()=>{adicionarLinha();setNaUltima(false);}}
          >
            Criar nova parcela
          </button>
      </div>
    </div>
  );
};
const ItensDaVenda = ({venda, setFormType }) => {
  const {
    crud,
    site,
  } = useProvider();
  const { get, loading } = crud || {};
  const navigate = useNavigate();
  const [itensDaVenda, setItensDaVenda] = useState([]);
  
  
  const buscarItensDaVenda = async () => {
    try{
      const response = await get(`/gvendas/vendas/${venda.id}/?expand=venda_itensvenda,produto`,'pagina');
      if(response && response.length){
        setItensDaVenda(response[0].venda_itensvenda);
      }
    }catch(err){
      if(err.response?.status === 404){
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente));
        navigate(`/clientes/${parseInt(venda?.cliente?.id || venda?.cliente)}`, {replace:true});
        setFormType('pagamentos');
      }
    }finally{
      
    }
  }
  
  useEffect(()=>{
    if(venda?.id){
      buscarItensDaVenda();
    }
  }, [venda?.id])  
  
  
  return (
        <>
            <div className="">
                <div className="list-group mt-3">
                    {itensDaVenda.length > 0 ? (
                        itensDaVenda.map((x) => (
                          <RenderizarProduto
                            key={x.produto.id}
                            onClick2 = {()=>console.log('')}
                            onClick3 = {()=>console.log('')}
                            //to={`/produtos/${x.id}`}
                            src={x.produto.foto_do_produto}
                            col2="col-auto"
                            titulo3={`${x.quantidade}x`}
                            //text3="Selecionado"
                            //bcolor={getCor(x.produto)}
                            lm='mb-1'
                            //icon:'bi-box-seam text-muted'
                            titulo={x.produto.nome_do_produto}
                            text2={parseFloat(x.preco_unitario).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            //text4={`${x.produto.controlar_estoque?`${x.produto.quantidade_em_estoque} unidades em estoque`:''}`}
                          />
                        ))
                    ) : (
                        !loading && <p className="text-center text-muted">Nenhum produto encontrado.</p>
                    )}
                </div>
            </div>
        </>
      )
};
const Comprovante = ({venda, setVenda, queryParams  }) => {
  const { 
    links, 
    setLinks, 
    btns, 
    setBtns,
    auth,
    site,
    hasPerms,
    hasPermsAnd,
    catalogo,
    crud,
    handleBaixar,
    handleEnviarWhats,
    handleCompartilhar,
  } = useProvider();
  const { get, loading } = crud || {};
  const [itensDaVenda, setItensDaVenda] = useState([]);
  const [pagamentos, setPagamentos] = useState([]);
  const [ultimosPagamentos, setUltimosPagamentos] = useState([]);
  const [pagamentosAberto, setPagamentosAberto] = useState([]);
  const [historico, setHistorico] = useState(null);
  const [empresa, setEmpresa] = useState(auth?.empresa);
  const [comObs, setComObs] = useState(false);
  const [comLink, setComLink] = useState(false);
  const [compPgmt, setCompPgmt] = useState(false);
  const [comExtrato, setComExtrato] = useState(false);
  const [atual, setAtual] = useState(true);
  const [estadoComprovante, setEstadoComprovante] = useState(null);
  const [comAbertos, setComAbertos] = useState(false);
  const divRef = useRef();
  const navigate = useNavigate();

  const tipo = queryParams.get('tipo')?.toLowerCase();
  const valor = queryParams.get('valor')?.toLowerCase();
  
  
  useEffect(() => {
    setLinks((prevLinks) => [
      {
        name: `${comObs ? 'Remover' : 'Incluir'} observações`,
        onClick: () => setComObs(!comObs),
        adicionado: true,
      },
      {
        name: `${comAbertos ? 'Remover' : 'Incluir'} débitos em aberto`,
        onClick: () => setComAbertos(!comAbertos),
        adicionado: true,
      },
      {
        divider: true,
        adicionado: true,
      },
      ...prevLinks,
    ]);
    
  
    // Função de limpeza para remover os itens ao sair da página
    return () => {
      setLinks((prevLinks) =>
          prevLinks.filter((link) =>!link.adicionado)
      );
    };
  }, [setLinks, comAbertos, comObs]);

//   useEffect(()=>{
// //    if(venda && itensDaVenda?.length>0 && pagamentos?.length>0 && empresa){
//       setBtns((prevBtns)=>([
//         {icon:'bi-file-earmark-arrow-down', adicionado:true, onClick:() => {captureScreenshot({})}},
//         ...(!isNative?[{icon:'bx-copy-alt fs-3', adicionado:true, onClick:() => {captureAndWhatsaAppScreenshot()}}]:[]),
//         {icon:'bi-share', adicionado:true, onClick:() => {captureAndShareScreenshot({})}},
//         {icon:'bxl-whatsapp fs-3', adicionado:true, onClick:() => {isNative?captureAndWhatsaAppScreenshot():shareWhatsApp()}},
//         ...prevBtns
//       ]));
//       return () => {
//         setBtns((prevBtns) =>
//           prevBtns.filter((link) =>!link.adicionado)
//         );
//       }
// //    }
//   }, [isNative, setBtns, venda, comAbertos, comObs, atual, itensDaVenda?.length, pagamentos?.length, empresa, comLink, comExtrato])
  
  useEffect(() => {
    // 1. Definimos os botões baseados na plataforma
    const botoesParaAdicionar = [
      { 
        icon: 'bi-file-earmark-arrow-down', 
        adicionado: true, 
        onClick: () => captureScreenshot({nome:"Comprovante"}) 
      },
      // Botão de copiar (apenas Web/PWA)
      ...(!isNative ? [{ 
        icon: 'bx-copy-alt fs-3', 
        adicionado: true, 
        onClick: () => captureAndWhatsaAppScreenshot() 
      }] : []),
      { 
        icon: 'bi-share', 
        adicionado: true, 
        onClick: () => captureAndShareScreenshot() 
      },
      { 
        icon: 'bxl-whatsapp fs-3', 
        adicionado: true, 
        onClick: () => shareWhatsApp() 
      }
    ];
  
    // 2. Atualizamos o estado garantindo que não haja duplicatas
    setBtns((prevBtns) => {
      const baseLimpa = prevBtns.filter((btn) => !btn.adicionado);
      return [...botoesParaAdicionar, ...baseLimpa];
    });
  
    // 3. Limpeza ao desmontar ou atualizar
    return () => {
      setBtns((prevBtns) => prevBtns.filter((btn) => !btn.adicionado));
    };
  }, [isNative, venda, comAbertos, comObs, atual, itensDaVenda?.length, pagamentos?.length, empresa, comLink, comExtrato]);

  
  useEffect(()=>{
    if(tipo === "ultimo-pagamento"){
      setCompPgmt(true);
      setAtual(false);
      buscarDependencias();
    }
    if(compPgmt){
      setAtual(false);
    }
    if(!atual || compPgmt){
      setComAbertos(true);
    }
  }, [atual, comAbertos, compPgmt, tipo])
  
  const removerTipo=()=>{
    navigate("?tipo=");
  }
  
  
  const captureAndShareScreenshot = async() => {
    const title = `Comprovante da venda`;
    let texto = `Oi ${venda?.cliente?.nome?.trimStart().split(' ')[0]}\nAqui está o comprovante da compra`;
    if(empresa?.instrucoes || empresa?.agradecimento){
      texto = `${texto}\n\n======\n${empresa?.instrucoes || empresa?.agradecimento}`;
    }
    await handleCompartilhar(divRef, {
      title,
      text:texto,
      url:comLink?`https://${site?.domain}/p/${venda?.cliente?.hash_token}/flex/`:null
    })
  };
  
  const captureScreenshot = async ({ nome }) => {
    await handleBaixar(divRef, { nome: nome || 'Comprovante'});
  };
  
  const captureAndWhatsaAppScreenshot = async() => {
    let texto = `Oi ${venda?.cliente?.nome?.trimStart().split(' ')[0]}\nAqui está o comprovante da compra.`;
    if(empresa?.instrucoes || empresa?.agradecimento){
      texto = `${texto}\n\n======\n${empresa?.instrucoes || empresa?.agradecimento}`;
    }
          
    // if(comLink){
    //   texto+=`\n\n======\nDetalhes da compra:\nhttps://${site?.domain}${catalogo}?p=meus-pedidos&t=${venda?.cliente?.hash_token}&i=${venda?.id}`
    // }
          
    await handleCompartilhar(divRef, {
      title:'Comprovante',
      text:texto,
      url: !comLink?null:`https://${site?.domain}/p/${venda?.cliente?.hash_token}/flex/`,
      telefone:venda?.cliente?.telefone,
    })
  };
  
  const shareWhatsApp = async() => {
    if(isNative && comLink) {
      await captureAndWhatsaAppScreenshot();
      return
    }
    let texto = `Oi ${venda?.cliente?.nome.trimStart().split(' ')[0]}\n`;
    if(atual){
      const desc = `* _de ~${parseFloat(venda?.sub_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}~ por_ *`
      texto += `*Total:${parseFloat(venda?.desconto) > 0 ?desc:' '}${parseFloat(venda?.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}*`;
      texto += `\n_Ite${itensDaVenda.length>1?'ns':'m'} da compra_`;
      itensDaVenda.forEach(item => {
        texto += `\n* ${item.quantidade}x ${item.produto?.nome_do_produto} - ${parseFloat(item.preco_unitario||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`;
      });
      texto += `\n\n_Pagamento${pagamentos.length>1?'s':''}_`;
      pagamentos.forEach(item => {
        texto += `\n* ${dayjs(item.data_do_pagamento).format("DD/MM/YYYY")}  ${parseFloat(item.valor_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} ${item.pago ? ' - _(pago)_' : ''}`;
      });
    }
    if(comAbertos){
      const { listaAbertos, total} = comAbertosList();
      if(atual){
        texto += `\n\n`;
      }
      texto += `*Total em aberto ${parseFloat(total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}*`;
      texto += `\n_Última compra: ${venda?.cliente?.tempo_ultima_compra}_`;
      texto += `\n_Data${listaAbertos.length>1?'s':''}_`;
      listaAbertos.forEach(([data, item]) => {
        texto += `\n* ${dayjs(data).format("DD/MM/YYYY")}  ${parseFloat(item.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} ${item.pago ? ' - _(pago)_' : ''}`;
      });
    }
    
    if(comObs && venda?.observacoes){
      texto += `\n\n_===Obs:===_\n${venda?.observacoes}\n_=========_`;
    }
    
    
    if(empresa?.instrucoes || empresa?.agradecimento){
      texto += `\n\n===\n${empresa?.instrucoes || empresa?.agradecimento}`;
    }

    if(comLink){
      texto += `\n\nhttps://${site?.domain}/p/${venda?.cliente?.hash_token}/flex/`;
    }
    //await handleBaixar(divRef, {nome:"Comprovante"})
    await handleEnviarWhats(venda?.cliente?.telefone, texto);
  }
  
  const buscarDependencias = async () => {
    try{
      const urls = [
        `/gvendas/vendas/${venda.id}/?expand=venda_itensvenda,venda_pagamentos,cliente,produto,empresa`,
        `/gvendas/pagamentos/?pago=false&venda__cliente__in=${parseInt(venda?.cliente?.id||venda?.cliente)}&ordering=data_do_pagamento&limit=100`,
        `/gvendas/relatorios/${venda?.cliente?.id||venda?.cliente}/historico-de-compras/`,
        `/gvendas/pagamentos/?pago=true&venda__cliente__in=${parseInt(venda?.cliente?.id||venda?.cliente)}&ordering=-data_do_pagamento`,
      ];
      const response = await get(urls,'pagina');
      if(response && response.length){
        setVenda(response[0]);
        setItensDaVenda(response[0].venda_itensvenda);
        setPagamentos(response[0].venda_pagamentos);
        setPagamentosAberto(response[1].results);
        setHistorico(response[2]);
        setUltimosPagamentos(response[3].results);
      }
    }catch(err){
      if(err.response?.status === 404){
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente));
        navigate(`/vendas/${venda.id}`, {replace:true});
      }
    }finally{
      
    }
  }
  
  
  useEffect(()=>{
    if(venda?.id){
      buscarDependencias();
    }
  }, [venda?.id, comAbertos, venda?.juros_por_atraso, valor]) 
  
  const comAbertosList = () => {
    const lista = pagamentosAberto.sort(
      (a, b) => new Date(a.data_do_pagamento) - new Date(b.data_do_pagamento)
    );
  
    const agrupadoPorData = lista.reduce((acc, item) => {
      const data = item.data_do_pagamento;
      if (!acc[data]) {
        acc[data] = { items: [], data: data, total: 0 }; // Inicializa um objeto com os itens e a soma
      }
      acc[data].items.push(item);
      acc[data].total += parseFloat(item.valor_total); // Adiciona o valor ao total
      return acc;
    }, {});
  
    const listaAbertos = Object.entries(agrupadoPorData);
    const total = lista.reduce((acc, linha) => acc + parseFloat(linha.valor_total || 0), 0);
  
    return { listaAbertos, total }; // Retorna um objeto com os dois valores
  };
  
  const itensContent = () => {
    return (
      <>
        <div className="border-dashed-bottom mb-2">Itens</div>
        {itensDaVenda.map((item, index) => (
          <>
            <Row>
              <Col>
                {item.quantidade}x {item.produto.nome_do_produto}
              </Col>
              <Col xs="auto" className="text-end">{parseFloat(item.preco_unitario || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
            </Row>
            <Col xs={12} className="border-bottom"></Col>
          </>
        ))}
      </>
    );
  };
  const pagamentosContent = () => {
    const lista = pagamentos.sort((a, b) => new Date(a.data_do_pagamento) - new Date(b.data_do_pagamento));
    return (
      <>
        <div className="border-dashed-bottom mb-2">Forma de Pagamento</div>
        {lista.map((item, index) => (
          <>
            <Row>
              <Col>
                {parseFloat(item.total_de_juros_e_multa || 0)>0 && (<><s className="small">{item.data_do_vencimento}</s>{` `}</>)}
                {dayjs(item.data_do_pagamento).format("DD/MM/YYYY")}
              </Col>
              <Col xs="auto" className="text-end">
                {parseFloat(item.total_de_juros_e_multa||0)>0 ? (
                  <>
                    <i className="bx bi-info"></i>
                    <s className="small">
                      {parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </s>{` `}
                    {item.pago && (<i className="bx bx-check-circle"></i>)} 
                    {parseFloat(item.valor_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  </>
                ):(
                  <>
                    {item.pago && (<i className="bx bx-check-circle"></i>)} 
                    {parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  </>
                )} 
              </Col>
            </Row>
            <Col xs={12} className="border-bottom"></Col>
          </>
        ))}
      </>
    );
  };
  const abertosContent = () => {
    const { listaAbertos, total} = comAbertosList();
    return (
      <>
        <div className="border-dashed-bottom mb-2">Pagamentos em Aberto</div>
        {listaAbertos.map(([data, item]) => (
          <>
            <Row>
              <Col>
                {dayjs(data).format("DD/MM/YYYY")}
              </Col>
              <Col xs="auto" className="text-end">{parseFloat(item.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
            </Row>
            <Col xs={12} className="border-bottom"></Col>
          </>
        ))}
        <Row className="mt-2 mb-3">
          <Col>
            Total em Aberto
          </Col>
          <Col xs="auto" className="text-end">
            <b>
              {parseFloat(total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </b>
          </Col>
        </Row>
      </>
    );
  };
  const historicoContent = () => {
    return (
      <>
        <div className="border-dashed-bottom mb-2">Extrato de conta</div>
        {historico?.historico?.map((grupo, index) => (
          <div className="mb-3">
            {grupo.lista.map((item, index)=>(
              <>
                <Row>
                  <Col>{dayjs(grupo.data).format("DD/MM/YYYY")} {item.tipo==="compra"?"Compra":"Pagamento"}</Col>
                  <Col xs="auto">{item.tipo==="compra"?"+":"-"}{parseFloat(item.valor || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</Col>
                </Row>
                <Col xs={12} className="border-bottom"></Col>
              </>
            ))}
            <Row>
                <Col></Col>
                <Col xs="auto" className="text-end">
                  <div className="text-muted small border-dashed-top">
                    total {parseFloat(grupo.saldo || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                  </div>
                </Col>
              </Row>
          </div>
        ))}
        <div className="border-dashed-top">
          <Row>
            <Col>Total em aberto</Col>
            <Col xs="auto">
              <b>
                {parseFloat(historico?.total_divida || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </b>
            </Col>
          </Row>
        </div>
      </>
    );
  };
  const instrucoesContent = () => {
    if (!empresa?.instrucoes) return <></>
    return (
      <>
        <div className="border-dashed-bottom mb-2"></div>
        <ReactMarkdown
          children={empresa?.instrucoes}
          components={{
            p: ({ children }) => <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{children}</p>,
          }}
        />
      </>
    );
  };
  const ultimoPagamentoContent = (ultimosPagamentos) => {
      // Pega a primeira data
      const primeiraData = ultimosPagamentos[0]?.data_do_pagamento;
      
      // Filtra os pagamentos da primeira data
      const pagamentosDaPrimeiraData = ultimosPagamentos?.filter(p => p.data_do_pagamento === primeiraData);
      
      // Soma os valores
      const valorTotal = pagamentosDaPrimeiraData?.reduce((soma, p) => soma + parseFloat(p.valor), 0);
      
      return (
        <>
          <div className="border-dashed-bottom mb-2"></div>
          {parseFloat(valorTotal ||0) >0 && (
            <>
              <Row>
                <Col xs={12} className="text-center fs-3">
                  Pagamento recebido <i className="bx bx-like"></i>
                </Col>
                <Col xs={12} className="text-center text-muted">
                  {dayjs(primeiraData).format("dddd[,] DD/MMM [de] YYYY")}
                </Col>
                <Col xs={12} className="text-center fs-2">
                  {parseFloat(valorTotal || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                </Col>
              </Row>
            </>
          )}
        </>
      );
  };
  const vendaContent = () => {
    return (
      <>
        <div className="border-dashed-bottom mb-2"></div>
        {parseFloat(venda?.desconto ||0) >0 && (
          <>
            <Row>
              <Col>
                Total sem desconto
              </Col>
              <Col xs="auto" className="text-end">
                {parseFloat(venda?.sub_total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </Col>
            </Row>
            <Col xs={12} className="border-bottom"></Col>
            <Row>
              <Col>
                Desconto
              </Col>
              <Col xs="auto" className="text-end">
                {parseFloat(venda?.desconto || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </Col>
            </Row>
            <Col xs={12} className="border-bottom"></Col>
          </>
        )}
        {parseFloat(venda?.juros_multa ||0) >0 && (
          <>
            <Row>
              <Col>
                Juros e multa
              </Col>
              <Col xs="auto" className="text-end">
                {parseFloat(venda?.juros_multa || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </Col>
            </Row>
            <Col xs={12} className="border-bottom"></Col>
          </>
        )}
        <Row className="mt-2">
          <Col>
            Total da compra
          </Col>
          <Col xs="auto" className="text-end">
            <b>
              {parseFloat(venda?.total || 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
            </b>
          </Col>
        </Row>
      </>
    );
  };
  const empresaContent = () => {
    const anoAtual = new Date().getFullYear();
    const copyright = `© ${anoAtual} ${empresa?.nome_da_loja}`;
    return (
      <>
        <div className="text-center">
          <div className="fs-5">{empresa?.nome_da_loja}</div>
          <div className="text-center">
            {empresa?.agradecimento?(
              <>
                <ReactMarkdown
                  className=""
                  children={empresa?.agradecimento}
                  components={{
                    p: ({ children }) => <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{children}</p>,
                  }}
                />
              </>
            ):(
              <>Obrigado pela oportunidade em poder atender você! </>
            )}
          </div>
          <div className="small mt-3 text-muted">
            {copyright}
          </div>
        </div>
      </>
    );
  };
  const topoContent = () => {
    return (
      <>
        <Row className="align-items-center">
          <Col className="text-end">
            <div className="fs-3">{empresa?.nome_da_loja}</div>
            <div className="text-muted small">
              <ReactMarkdown>
                {empresa?.descricao} 
              </ReactMarkdown> 
            </div>
          </Col>
          <Col xs="auto">
            <RenderizarFoto src={`https://${site?.domain}${empresa?.logomarca}`} alt="" />
          </Col>
        </Row>
      </>
    );
  };
  const clienteContent = () => {
    const vtotal = pagamentosAberto.reduce((acc, linha) => acc + parseFloat(linha.valor_total || 0), 0);
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Janeiro é 0
    const ano = dataAtual.getFullYear();
    
    const horas = String(dataAtual.getHours()).padStart(2, '0');
    const minutos = String(dataAtual.getMinutes()).padStart(2, '0');
    
    const opcoes = { timeZoneName: 'short' };
    const fusoHorario = dataAtual.toLocaleTimeString('pt-BR', opcoes).split(' ')[2];
    
    const dataFormatada = `${dia}/${mes}/${ano} às ${horas}:${minutos}`;
    
    return (
      <>
        <Row className="align-items-center">
          <Col>
            {atual && (
              <div className="">Data da compra: {dayjs(venda?.data_da_venda).format("DD/MM/YYYY")}</div>
            )}
            <div className="">Cliente: {venda?.cliente?.nome_do_cliente?.trimStart().split(' ')[0]}</div>
            <div className="text-muted small">
              {atual ? (
                <>
                  <Row>
                    <Col>Pago</Col>
                    <Col xs="auto">Total da compra</Col>
                  </Row>
                  <BarraDeProgresso valor={venda?.total_pago} total={venda?.total} variant="secondary"/>
                  <Row>
                    <Col>
                      {parseFloat(venda?.total_pago||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                    </Col>
                    <Col xs="auto">
                      {parseFloat(venda?.total||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} 
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <div>Última compra: {venda?.cliente?.tempo_ultima_compra}</div>
                  Em aberto: {parseFloat(vtotal||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} 
                </>
              )}
              <div>
                <i>Gerado em {dataFormatada}</i>
              </div>
            </div>
          </Col>
        </Row>
      </>
    );
  };
  
    
  return (
    <>
      <Row className="justify-content-center align-items-center mt-3">
        <Col></Col>
        <Col xs="auto" className="text-end">
          <Form.Check
                type="switch"
                id="custom-switch-atual"
                label="Venda atual"
                checked={atual}
                onChange={(e) => {
                  setAtual(e.target.checked); 
                  if (!e.target.checked) {
                    setComAbertos();
                  }else{
                    removerTipo();
                    setCompPgmt(false);
                  }
                }}
            />
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center">
        <Col></Col>
        <Col xs="auto" className="text-end">
          <Form.Check
                type="switch"
                id="custom-switch-comLink"
                label="Último pagamento"
                checked={compPgmt}
                onChange={(e) => {
                  setCompPgmt(e.target.checked);
                  removerTipo();
                }}
            />
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center">
        <Col></Col>
        <Col xs="auto" className="text-end">
          <Form.Check
                type="switch"
                id="custom-switch-obs"
                label="Incluir Observações"
                checked={comObs}
                onChange={(e) => setComObs(e.target.checked)}
            />
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center">
        <Col></Col>
        <Col xs="auto" className="text-end">
          <Form.Check
                type="switch"
                id="custom-switch-abertos"
                label="Incluir Valores em aberto"
                checked={comAbertos}
                onChange={(e) => {
                  setComAbertos(e.target.checked);
                  if (!e.target.checked) {
                    setAtual(true);
                    removerTipo();
                  }
                }}
            />
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center">
        <Col></Col>
        <Col xs="auto" className="text-end">
          <Form.Check
                type="switch"
                id="custom-switch-comExtrato"
                label="Incluir Extrato de conta"
                checked={comExtrato}
                onChange={(e) => {
                  setComExtrato(e.target.checked);
                }}
            />
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center">
        <Col></Col>
        <Col xs="auto" className="text-end">
          <Form.Check
                type="switch"
                id="custom-switch-comLink-comprovante"
                label="Incluir link do comprovante"
                checked={comLink}
                onChange={(e) => {
                  setComLink(e.target.checked);
                  if (!e.target.checked) {
                    setAtual(true);
                  }
                }}
            />
        </Col>
      </Row>
      <div className="d-flex justify-content-center mt-3">
        <div className="pb-5 pt-5 border rounded pe-4 ps-4" ref={divRef} style={{ width: '450px' }}>
          <div className="py-3">
            {topoContent()}
          </div>
          <div className="py-1">
            {clienteContent()}
          </div>
          {compPgmt && (
            <>
              <div className="py-3">
                {ultimoPagamentoContent(ultimosPagamentos)}
              </div>
            </>
          )}
          {atual && (
            <>
              <div className="py-3">
                {itensContent()}
              </div>
              <div className="py-3">
                {pagamentosContent()}
              </div>
              <div className="py-4">
                {vendaContent()}
              </div>
            </>
          )}
          {comObs && (
            <div className="py-1 text-muted small">
              <div className="small text-muted">
                Observações:
              </div>
              <ReactMarkdown
                className="p-2 border rounded"
                children={venda?.observacoes}
                components={{
                  p: ({ children }) => <p style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{children}</p>,
                }}
              />
            </div>
          )}
          {comAbertos && (
            <div className="py-1">
              {abertosContent()}
            </div>
          )}
          {(venda?.juros_por_atraso || venda?.juros_multa > 0) && (
            <>
              <div className="text-muted text-center small">
                 Em caso de atraso no pagamento, serão cobrados juros de {empresa?.juros?.juros_mensal}% ao mês e multa de {empresa?.juros?.multa_percentual}% sobre o valor da parcela.
              </div>
            </>
          )}
          {((comAbertos && pagamentosAberto.length >0) || venda?.total_aberto > 0) && (
            <div className="py-1">
              {instrucoesContent()}
            </div>
          )}
          {comExtrato && (
            <div className="my-1">
              {historicoContent()}
            </div>
          )}
          <div className="pt-3 pb-5">
            {empresaContent()}
          </div>
        </div>
      </div>
    </>
  )
};
const VendaDetails = () => {
  const { id, id_pagamento } = useParams();
  const { 
    setLinks, 
    setBtns,
    crud,
    auth,
    buscarDadosPorId,
    salvarDados,
    setTitle,
    hasPerms,
    site,
  } = useProvider();
  const { get, put, del, patch, loading } = crud || {};
  const [venda, setVenda] = useState(null);
  const [qrPago, setQrPago] = useState(false);
  const [juros, setJuros] = useState(auth?.empresa?.juros);
  const [configuracoes, setConfiguracoes] = useState(auth?.empresa?.configuracoes);
  const [jurosPorAtraso, setJurosPorAtraso] = useState(false);
  const [formType, setFormType] = useState(id_pagamento?'parcela':'comprovante');
  const navigate = useNavigate();
  const isInitialRender = useRef(true);
  const switchJurosRef = useRef(null);
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tipo = queryParams.get('tipo')?.toLowerCase();
  
  useEffect(()=>{
    if(tipo==="ultimo-pagamento"){
      setFormType("comprovante");
    }
  },[tipo])
  
  setTitle('Venda');
  
    
  useEffect(() => {
      let link = [
          { name: 'Extrato', onClick:()=> { setFormType('comprovante') }},
          { name: 'Forma de pagamento', onClick:()=> { setFormType('pagamentos') }},
          { name: 'Itens da Venda', onClick:()=> { setFormType('itens') }},
          { name: 'Editar Pagamentos', onClick:()=> { setFormType('editar-pagamentos') }},
          { divider: true, name: 'Perfil do Cliente', to:`/clientes/${venda?.cliente?.id}`},
          { divider: true, name: 'Todas as vendas', to:`/clientes/${venda?.cliente?.id}/compras`},
          { name: 'Todos os pagamentos', to: `/clientes/${venda?.cliente?.id}/pagamentos`},
          { divider: true, name: 'Excluir esta Venda', onClick:()=> { excluirVenda() }},
          //{ name: 'Configurações', to: '/configuracoes' },
      ]
      setLinks(link);
      setBtns([
        {icon:'bi-trash', onClick:() => {excluirVenda()}},
      ]);
      return () => {setLinks([]); setBtns([]);}
  }, [setLinks, setBtns, formType, venda?.cliente?.id]);
  
  const isConsultaCarregada = useRef(false);
  const buscarVendaLocal = async () => {
    try{
      const vendaLocal = await buscarDadosPorId("db_vendas",parseInt(id));
      if(vendaLocal){
        if (isConsultaCarregada.current) return;
        setVenda(vendaLocal);
        setJurosPorAtraso(vendaLocal?.juros_por_atraso);
      }
    }catch(err){

    }finally{

    }
  }
  const buscarVenda = async () => {
    try{
      const response = await get(`/gvendas/vendas/${id}/?expand=cliente`, 'pagina');
      if(response && response.length){
        isConsultaCarregada.current = true;
        setVenda(response[0]);
        setJurosPorAtraso(response[0].juros_por_atraso);
      }
    }catch(err){
      if(err.response?.status === 404){
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente));
        navigate(`/clientes/${parseInt(venda?.cliente?.id || venda?.cliente)}`, {replace:true});
        setFormType('pagamentos');
      }
    }finally{
      
    }
  }
  
  
  const atualizarVenda = async() => {
    try{
      //alert(JSON.stringify(venda))
      const formData = new FormData();
      formData.append('juros_por_atraso', !!jurosPorAtraso);
      formData.append('data_da_venda', venda.data_da_venda);
      formData.append('observacoes', venda.observacoes || ``);
      const response = await patch(formData, `/gvendas/vendas/${venda.id}/?filtros=juros_por_atraso`);
      if (response.length){
        baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente))
        setVenda((prevVenda)=>({
          ...prevVenda,
          juros_por_atraso:response[0].juros_por_atraso
        }));
      }
      
    }catch(err){
      if (err.code === 'ERR_NETWORK' || err.code === 'ECONNABORTED' || !err.response ) {
        const cliLocal = venda?.cliente?.nome_do_cliente ? venda?.cliente : await buscarDadosPorId("db_clientes", parseInt(venda?.cliente?.id || venda?.cliente));
        const formData = {
          'juros_por_atraso':jurosPorAtraso,
          'data_da_venda':venda?.data_da_venda,
          'observacoes':venda?.observacoes
        }
        await salvarDados('db_sync', {
          id:`venda_detalhes_${venda?.id}`,
          metodo: "PATCH",
          titulo: `Atualizar venda`,
          descricao: `
            <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr><th>${cliLocal?.nome_do_cliente || `Cliente Id: ${venda?.cliente?.id|| venda?.cliente}`}</th></tr>
              </thead>
              <tbody>
                <tr><td>Juros: ${jurosPorAtraso}</td></tr>
                <tr><td>Obs: ${venda?.observacoes}</td></tr>
                <tr><td>Data: ${dayjs(venda?.data_da_venda).format("DD/MM/YYYY")}</td></tr>
              </tbody>
            </div>
          `,
          url: `/gvendas/vendas/${venda.id}/?filtros=juros_por_atraso`,
          dados: formData,
          tipo:"baixar-cliente",
          id: venda?.cliente?.id || venda?.cliente,
          data: new Date().toLocaleString("sv-SE"),
        });
        //Colocar url da fila;
        //navigate(`/painel/sync`, { replace: true });
      }
      else {
        Swal.fire({
            title: `Erro ${err.status || err.code}`,
            text: err.response?.data?.detail || 'Falha ao atualizar venda',
            icon: "error"
        });
      }
    }finally{

    }
  }
  
  const excluirVenda = async() => {
    Swal.fire({
      title: "Exluir esta venda?",
      text: "Excluir venda definitivo, esta ação não pode ser revertida.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Sim, excluir!"
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
          await del(`/gvendas/vendas/${venda.id}/`);
          navigate(`/clientes/${venda?.cliente?.id}/compras`, {replace:true});
          Toast.fire({
              icon: "success",
              title: "Venda excluída com sucesso"
          });
          baixarCliente(parseInt(venda?.cliente?.id || venda?.cliente))
        }catch(err){
         // alert(JSON.stringify(err.response))
          Swal.fire({
            title: `Erro ${err.status || err.code}`,
            text: err.response?.data?.detail || 'Esta venda não pode ser excluída',
            icon: "error"
          });
        }finally{
        }
      }
    });
  }
  
  const alterarTipoCobranca = async () => {
    
  }
  
useEffect(() => {
    // carregamento imediato
    buscarVendaLocal();
    buscarVenda();
  }, [id, id_pagamento]);
  
  
  
  useEffect(()=>{
    if(venda){
      setVenda((prevVenda)=>({
        ...prevVenda,
        total_aberto: prevVenda.total - prevVenda.total_pago,
      }))
    }
  },[venda?.total_pago])
  
  useEffect(()=>{
    if(venda){
      if (isInitialRender.current) {
        isInitialRender.current = false;
        return; // Ignora o carregamento inicial
      }
      atualizarVenda();
    }
  },[venda?.data_da_venda, jurosPorAtraso, venda?.observacoes])
  
  
  
  return (<>
    <PerfilParte cliente={venda?.cliente}/>
    <div className="row">
      <div className="col">
        <Button variant="outline-dark" onClick={()=>navigate(`/clientes/${parseInt(venda?.cliente?.id||venda?.cliente)}/compras`)}>
          Todas as vendas
        </Button>
      </div>
      <div className="col-auto">
        <InputGroup>
          <span className="input-group-text">Venda em</span>
          <Form.Control
            type="date"
            readOnly={formType !== 'editar-pagamentos'}
            value={venda?.data_da_venda}
            onChange={(e) => setVenda((prevVenda)=>({
              ...prevVenda,
              data_da_venda:e.target.value
            }))}
          />
        </InputGroup>
      </div>
      <div className="col-12 py-2">

      </div>
      <div className="col-12 py-2">
        <Form.Control
          as="textarea"
          placeholder="Observações"
          rows={3}
          value={venda?.observacoes}
          onChange={(e) => setVenda((prevVenda)=>({
            ...prevVenda,
            observacoes:e.target.value
          }))}
        />
      </div>
      {juros && configuracoes?.juros_multa && (
        <Col>
            <Form.Check
                  ref={switchJurosRef}
                  id="switch_juros_por_atraso"
                  type="switch"
                  label="Cobrar juros multa se tiver atraso"
                  checked={jurosPorAtraso}
                  onChange={(e) => {
                    setJurosPorAtraso(e.target.checked);
                    if (e.target.checked && !juros) {
                      navigate('/config/juros');
                    }
                  }}
            />
        </Col>
      )}
    </div>
    <div className="">
      {formType !== "editar-pagamentos" && (<>
          {(hasPerms("loja.view_venda")  && parseFloat(venda?.cliente?.total_aberto || 0)>0) && (<>
            <div className="text-center py-4">
                <OpcoesPagamento 
                  perm_online={hasPerms("pagamento_online.view_configurarpagamento")}
                  clienteId={parseInt(venda?.cliente?.id || 0)} totalAberto={parseFloat(venda?.cliente?.total_aberto || 0)} pagar={parseFloat(venda?.total_aberto || 0)} 
                  conInstrucoes={false} 
                  setPago={setQrPago} 
                  ocultarValor={true}
                  hash_token={venda?.cliente?.hash_token}
                  redirecionar={`/vendas/${parseInt(venda?.cliente?.id || venda?.cliente)}/${venda?.id}?tipo=ultimo-pagamento`}
                />
            </div>
            <div className="text-center">
              <Button variant="outline-dark" size="sm" onClick={()=>navigate(`/clientes/${parseInt(venda?.cliente?.id || venda?.cliente)}/pagamentos-editar/`)}>Alterar datas de vencimentos</Button>
            </div>
          </>)}
      </>
      )}
      <div className="py-3">
        {/* Nav Tabs */}
        <Tab.Container id="details-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
          <Nav variant="tabs" className="justify-content-center fs-4">
            {id_pagamento && (
              <Nav.Item>
                <Nav.Link eventKey="parcela"><i class='bx bx-money-withdraw'></i></Nav.Link>
              </Nav.Item>
            )}
            <Nav.Item>
              <Nav.Link eventKey="itens"><i class='bx bx-basket'></i></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="pagamentos"><i class='bx bx-dollar'></i></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="editar-pagamentos"><i class='bx bx-edit'></i></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="comprovante"><i class='bx bx-receipt'></i></Nav.Link>
            </Nav.Item>
          </Nav>
  
          <Tab.Content className="">
            {/* Painel de Login */}
            {formType === 'parcela' && <Parcela  venda={venda} setVenda={setVenda} id_pagamento={id_pagamento} setFormType={setFormType}/>}
            {formType === 'itens' && <ItensDaVenda venda={venda} />}
            {formType === 'pagamentos' && <Pagamento venda={venda} setVenda={setVenda} setFormType={setFormType}/>}
            {formType === 'editar-pagamentos' && <PagamentoEditar jurosMulta={juros} venda={venda} setVenda={setVenda} setFormType={setFormType}/>}
            {formType === 'comprovante' && <Comprovante venda={venda} setVenda={setVenda} queryParams={queryParams} />}
          </Tab.Content>
        </Tab.Container>
      </div>
    </div>
  </>)
}

export default VendaDetails;
